import { LinkProvider, type UiLinkProps } from "@rhema/ui";
import { Link, Outlet } from "react-router";
import { SessionProvider } from "../session/session";

function RouterLink({ href, ...rest }: UiLinkProps) {
  // External and same-page links stay plain anchors.
  if (/^(https?:|mailto:|#)/.test(href)) return <a href={href} {...rest} />;
  return <Link to={href} {...rest} />;
}

export function Root() {
  return (
    <SessionProvider>
      <LinkProvider component={RouterLink}>
        <Outlet />
      </LinkProvider>
    </SessionProvider>
  );
}
